import React from "react";
import { Dialog, Button, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { i18n } from "../../translate/i18n";

const REVOKE_WINDOW_MS = 48 * 60 * 60 * 1000;

const useStyles = makeStyles((theme) => ({
  paper: {
    borderRadius: 8,
    padding: theme.spacing(3, 4),
    minWidth: 420,
    maxWidth: 520,
    backgroundColor: theme.palette.background.paper,
  },
  title: {
    fontSize: "1.1rem",
    fontWeight: 400,
    marginBottom: theme.spacing(3),
    color: theme.palette.text.primary,
  },
  actions: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: theme.spacing(1),
    flexWrap: "wrap",
  },
  pillButton: {
    borderRadius: 24,
    textTransform: "none",
    padding: theme.spacing(0.75, 2.5),
    fontWeight: 400,
    borderColor: theme.palette.primary.main,
    color: theme.palette.primary.main,
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
      borderColor: theme.palette.primary.main,
    },
  },
  textButton: {
    textTransform: "none",
    color: theme.palette.primary.main,
    fontWeight: 400,
    padding: theme.spacing(0.75, 1.5),
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}));

const DeleteMessageModal = ({ open, message, onClose, onConfirm }) => {
  const classes = useStyles();

  if (!message) return null;

  const isMine = message.fromMe;
  const createdAt = message.createdAt || message.timestamp;
  const messageAge = createdAt
    ? Date.now() - new Date(createdAt).getTime()
    : Infinity;
  const canRevoke = isMine && messageAge <= REVOKE_WINDOW_MS;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{ className: classes.paper }}
    >
      <Typography className={classes.title}>
        {i18n.t("deleteMessageModal.title")}
      </Typography>
      <div className={classes.actions}>
        {canRevoke && (
          <Button
            onClick={() => onConfirm(true)}
            variant="outlined"
            className={classes.pillButton}
          >
            {i18n.t("deleteMessageModal.forEveryone")}
          </Button>
        )}
        <Button
          onClick={() => onConfirm(false)}
          variant="outlined"
          className={classes.pillButton}
        >
          {i18n.t("deleteMessageModal.forMe")}
        </Button>
        <Button onClick={onClose} className={classes.textButton}>
          {i18n.t("deleteMessageModal.cancel")}
        </Button>
      </div>
    </Dialog>
  );
};

export default DeleteMessageModal;
